import React from 'react';
import { Col,Form } from 'react-bootstrap';

const SelectItemAgente = ({props}) => {
  return(
    <Col xs={12} md={4}>
      <React.Fragment>
        <h3 className="ws_select_type">Agentes</h3>
        <Form.Select 
        aria-label="select agentes" 
        {...props}
        >
          <option value="0">TODOS</option>
          <option value="1">AGENTES</option>
          <option value="2">PROMOTORIAS</option>
        </Form.Select>
      </React.Fragment>
    </Col>
  )
}

const SelectItemTypeAgente = ({props}) => {
  return(
    <Col xs={12} md={4}>
      <React.Fragment>
        <h3 className="ws_select_type">Tipos</h3>
        <Form.Select 
        aria-label="select tipos" 
        {...props}
        >
          <option value="0">TODOS</option>
          <option value="1">FA</option>
          <option value="2">CONSOLIDADO</option>
          <option value="3">ESPECIAL</option>
        </Form.Select>
      </React.Fragment>
    </Col>
  )
}

export const SelectAgente = ({...props}) => {
  return (
    <SelectItemAgente props={props} />
  )
}

export const SelectTypeAgente = ({...props}) => {
  return(
    <SelectItemTypeAgente props={props} />
  )
}
